import { getCsrfToken } from '../lib/utils'

export async function create(userId, gameId, characterId = null) {
  const payload = {
    user_id: userId
  }
  if (characterId) {
    payload.character_id = characterId
  }

  const response = await fetch(`/games/${gameId}/impersonation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify(payload),
    credentials: 'same-origin'
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to start impersonation')
  }

  return response.json()
}

export async function destroy(gameId) {
  const response = await fetch(`/games/${gameId}/impersonation`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': getCsrfToken()
    },
    credentials: 'same-origin'
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to stop impersonation')
  }

  return response.json()
}

export async function checkStatus(gameId) {
  const response = await fetch(`/impersonations/status?game_id=${gameId}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': getCsrfToken()
    },
    credentials: 'same-origin'
  })

  if (!response.ok) {
    throw new Error('Failed to check impersonation status')
  }

  return response.json()
}

export async function getAvailableGames(page = 1, perPage = 20, search = '') {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString(),
    ...(search && { search: search })
  });

  const response = await fetch(`/impersonations/available_games?${params}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': getCsrfToken()
    },
    credentials: 'same-origin'
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch available games');
  }

  return response.json();
}